import { styled } from '../../components-core/packages/components-core/dist/theme-provider/index';

export const TopContainer = styled.div`
    width: 100vw;
`;
